import React, { useState } from 'react';
import useHomeLinkMode from "../../../hooks/useHomeLinkMode";
import useHaveClubPeque from "../../../hooks/useHaveClubPeque"
import './nav-menu.scss';

const NavMenu = ({ activeMenu, menuOptions, activeMegaMenu, setActiveMegaMenu }) => {
    const { homeLink } = useHomeLinkMode();
    const [activeOption, setActiveOption] = useState(null)
    const {haveClubPeque} = useHaveClubPeque()

    const menuDisplay = (item, index) => {
        if (activeMegaMenu === item) {
            setActiveMegaMenu(null)
            setActiveOption(null)
        } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'ui :: home :: menu',
                'eventAction': 'click',
                'eventLabel': item.nombreDeLaOpcion
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackGA4',
                'event_type': 'user_interaction',
                'section': 'home',
                'action': 'click',
                'element': item.nombreDeLaOpcion,
                'flow': 'menu',
                'screen_name': 'home'
            });

            setActiveMegaMenu(item)
            setActiveOption(index)
        }
    }

    return (
        <ul className="f-m-nav-menu">
            {menuOptions.map((item, index) => {  
                return(                
                <li key={index}
                className={
                    "f-m-nav-item" +
                    ((
                      haveClubPeque
                        ? activeMenu === index
                        : activeMenu - 1 === index || activeOption === index
                    )
                      ? "__active "
                      : "") +
                    (index == 0 ? " home-space" : "")
                  }
                >
                        {item.opcionesSubmenu ?
                            <div className="f-m-nav-item__menu" onClick={() => { menuDisplay(item, index) }}>
                                <a>{item.nombreDeLaOpcion}</a>
                                <span className="icon-ico-arrow-down" ></span>
                            </div>
                            : <a href={`${item.redireccionDeLaOpcion || ''}`}> {item.nombreDeLaOpcion}</a>
                        }
                </li>

            )})}
        </ul>
    );
}

export default NavMenu
